/**
 * Constants for resource hooks
 */

/**
 * Maximum query string length before switching to POST
 */
export const MAX_QUERYSTRING_LENGTH = 2048;

/**
 * Default stale time for resource queries (60 seconds)
 * This prevents unnecessary refetches while keeping data reasonably fresh
 */
export const DEFAULT_STALE_TIME = 60 * 1000;

/**
 * Default stale time for search queries (10 seconds)
 */
export const DEFAULT_SEARCH_STALE_TIME = 10 * 1000;
